import { Button } from "@mui/material";
import { Auth } from "aws-amplify";
import React from "react";
import { useNavigate } from "react-router-dom";
import module from "./GoogleButton.module.css";

const GoogleButton = ({
  onClick,
  label = "Googleでログイン",
  id = null,
  disabled,
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: "100%",
        color: "black",
        borderColor: "#DEE5EE",
        border: "1px solid rgba(222, 229, 238, 1)",
        position: "relative",
        fontWeight: "bold",
        textTransform: "none",
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.15)",
      }}
      variant="outlined"
      id={id}
    >
      <>
        <img
          src={process.env.PUBLIC_URL + "/png/google.png"}
          className={module.googleLogo}
        />
        {label}
      </>
    </Button>
  );
};

export default GoogleButton;
